import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["id", "graphql", "onRendered"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PaletteContent from "@/components/PaletteContent";
import HtmlSnippet from "@/components/HtmlSnippet";
import { useQuery } from "@apollo/client";
import { useCallback, useRef, useEffect, useState, cloneElement } from "react";
// schema = {
//  id: id,
//  type: "palette" or "html_snippet",
//  header: {text: "", link: {href: ""}
//  graphql: {query: "graphql query", variables: {variables}, path: ""}
//  viewType: "slider" or "grid" or "list" or "pickuplist" or "carousel"
// }
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PseudoCanvasStructure(_ref) {
  let {
    schema,
    onRendered
  } = _ref;
  const {
    type,
    id
  } = schema;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [type === "palette" && /*#__PURE__*/_jsx(PseudoPalette, _objectSpread(_objectSpread({}, schema), {}, {
      onRendered: onRendered
    })), type === "html_snippet" && /*#__PURE__*/_jsx(HtmlSnippet, {
      id: id
    })]
  });
}
function PseudoPalette(_ref2) {
  let {
      id,
      graphql,
      onRendered
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const {
    query,
    options,
    path
  } = graphql;
  const _useQuery = useQuery(query, options),
    {
      data
    } = _useQuery,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  const items = data === null || data === void 0 ? void 0 : data[path];
  useEffect(() => {
    if (items && items !== null && items !== void 0 && items.pageInfo) {
      onRendered(id, items.pageInfo.totalCount > 0);
    }
  }, [items, onRendered]);
  return /*#__PURE__*/_jsx(PaletteContent, _objectSpread(_objectSpread({
    items: items
  }, props), result));
}
export default function PseudoCanvas(_ref3) {
  let {
    schemas,
    noContent
  } = _ref3;
  const schemaResults = useRef();
  const {
    0: noResult,
    1: setNoResult
  } = useState(false);
  const handleRenderd = useCallback((key, value) => {
    if (schemaResults.current && Object.keys(schemaResults.current).includes(key)) {
      schemaResults.current[key] = value;
      const values = Object.values(schemaResults.current);
      if (values.every(v => v === false)) {
        setNoResult(true);
      } else {
        setNoResult(false);
      }
    }
  }, [schemaResults]);
  useEffect(() => {
    const entries = schemas.map(schema => [schema.id, null]);
    schemaResults.current = Object.fromEntries(entries);
    setNoResult(false);
  }, [schemas]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [schemas.map(schema => /*#__PURE__*/_jsx(PseudoCanvasStructure, {
      schema: schema,
      onRendered: handleRenderd
    }, `pseudo-${schema.id}`)), noResult && noContent && /*#__PURE__*/cloneElement(noContent)]
  });
}